import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cargando)?_c(VProgressLinear,{attrs:{"indeterminate":true,"color":_vm.configuracion.color}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }